import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {generateRoutePath, getBowserState} from '@epic-core/common';
import {getOptImage} from 'epic-ue-shared';
import Message from '../message/Message';

export default class UXHeader extends Component {
    static propTypes = {
        content: PropTypes.object
    };

    render() {
        const content = this.props.content || {};
        const {mobile} = getBowserState();
        const {egLogo, uxTitle, title, subTitle, bgImg, bgColor} = content;
        const buttons = content.buttons || [];
        let styles = {backgroundImage: `url(${getOptImage({url: bgImg || '', width: 1920})})`};

        if (mobile) {
            styles = {backgroundColor: bgColor};
        }

        return (
            <div className="ux-header" style={styles}>
                <div className="content-wrapper">
                    <div className="content-wrapper-bg" style={{backgroundColor: bgColor}} />
                    <div className="content-inner">
                        <div className="ux-logo">
                            <img src={getOptImage({url: egLogo, width: 200})} alt={uxTitle} />
                            <h2>{uxTitle}</h2>
                        </div>
                        <h1>{title}</h1>
                        <div className="h2">{subTitle}</div>
                        {buttons.map((button) => (
                            <a
                                href={button.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-lg btn-primary"
                                key={button.label}>
                                {button.label}
                            </a>
                        ))}
                        <div className="privacy-link">
                            <Link to={generateRoutePath('privacypolicy')}>
                                <Message code="epic.footer.privacy_policy" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
